import { useMemo } from "react"
import routes from "routes"
import Link from "next/link"
import { UserData } from "types"
import { WorkItem } from "../../../models/WorkItem/WorkItem"

const UserName: React.FC<{ item: WorkItem }> = ({ item }) => {
  const userRole: {
    novelist: UserData
    illustrator: UserData
  } = useMemo(() => {
    return {
      novelist: item.user_role === 1 ? item.user : item.applied_user,
      illustrator: item.user_role !== 1 ? item.user : item.applied_user,
    }
  }, [item])

  return (
    <ul className="p-ranking-works-user">
      <li className="p-ranking-works-user-novelist">
        <Link href={routes.userTop(userRole.novelist.display_name)}>
          <a className="p-ranking-works-user-anchor">
            {userRole.novelist.name}
          </a>
        </Link>
      </li>
      <li className="p-ranking-works-user-illustrator">
        <Link href={routes.userTop(userRole.illustrator.display_name)}>
          <a className="p-ranking-works-user-anchor">
            {userRole.illustrator.name}
          </a>
        </Link>
      </li>
    </ul>
  )
}

export default UserName
